import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';
import classNames from 'classnames';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    marginTop: spacing(4.5),
    display: 'grid',
    gap: spacing(5),
    height: 'fit-content',
  },
  summaryCard: {
    border: `1px solid ${primary.bluish9}`,
    borderRadius: 24,
    padding: spacing(5, 4),
    backgroundColor: primary.bluish9,
    width: 180,
    height: 'fit-content',
    display: 'grid',
    justifyContent: 'center',
  },
  genderSummaryCard: {
    gap: 15,
  },
  totalLabelWrapper: {
    display: 'grid',
    justifyContent: 'end',
  },
  summaryTitle: {
    color: primary.black,
  },
  metricBlock: {
    display: 'grid',
    justifyItems: 'end',
    rowGap: spacing(1),
  },
  rectangleWrapper: {
    width: 133,
    height: 7,
    backgroundColor: '#D9D9D9',
  },
  progress: {
    backgroundColor: primary.bluish1,
    height: 7,
  },
  metricValue: {
    color: primary.bluish1,
    marginBottom: spacing(6),
  },
  rows: {
    display: 'grid',
    gap: spacing(4),
  },
  label: {
    color: primary.bluish2,
  },
  valueWrapper: {
    justifyContent: 'space-between',
    display: 'flex',
    width: '100%',
  },
}));

const NO_DATA_DEFAULT = 'no_data';

const HeadcountCards = ({ translations, headcountData }) => {
  const classes = useStyles();
  const perYearValues = Object.values(
    headcountData?.total_employees_per_year
  ).map(v => Number(v));
  const maxPerYear = perYearValues.length > 0 ? Math.max(...perYearValues) : 0;

  const currentYearTotal = headcountData?.total_employees;
  const totalEmployees = Math.max(maxPerYear, currentYearTotal);

  return (
    <div className={classes.root}>
      <div className={classes.summaryCard}>
        <div className={classes.totalLabelWrapper}>
          <Typography className={classes.summaryTitle} variant="subtitle1">
            {translations.totalEmployeesTitle}
          </Typography>
        </div>
        <div className={classes.totalLabelWrapper}>
          <Typography variant="h1" className={classes.metricValue}>
            {headcountData?.total_employees}
          </Typography>
        </div>
        <div className={classes.rows}>
          {Object.entries(headcountData?.total_employees_per_year)
            .toReversed()
            .map(([key, value]) => {
              return (
                <div key={`year_${key}`} className={classes.metricBlock}>
                  <div className={classes.rectangleWrapper}>
                    <div
                      className={classes.progress}
                      style={{
                        width: totalEmployees
                          ? ((value || 0) * 133) / totalEmployees
                          : 0,
                      }}
                    />
                  </div>
                  <div className={classes.valueWrapper}>
                    <Typography className={classes.label} variant="body1">
                      {key === NO_DATA_DEFAULT ? translations.noData : key}
                    </Typography>
                    <Typography className={classes.label} variant="subtitle1">
                      {value}
                    </Typography>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
      <div
        className={classNames(classes.summaryCard, classes.genderSummaryCard)}
      >
        <div className={classes.totalLabelWrapper}>
          <Typography className={classes.summaryTitle} variant="subtitle1">
            {translations.genderTitle}
          </Typography>
        </div>
        <div className={classes.rows}>
          {Object.entries(headcountData?.total_employees_per_gender).map(
            ([key, value]) => {
              return (
                <div key={`gender_${key}`} className={classes.metricBlock}>
                  <div className={classes.rectangleWrapper}>
                    <div
                      className={classes.progress}
                      style={{
                        width: currentYearTotal
                          ? ((value || 0) * 133) / currentYearTotal
                          : 0,
                      }}
                    />
                  </div>
                  <div className={classes.valueWrapper}>
                    <Typography className={classes.label} variant="body1">
                      {key === NO_DATA_DEFAULT ? translations.noData : key}
                    </Typography>
                    <Typography className={classes.label} variant="subtitle1">
                      {value}
                    </Typography>
                  </div>
                </div>
              );
            }
          )}
        </div>
      </div>
      <div
        className={classNames(classes.summaryCard, classes.genderSummaryCard)}
      >
        <div className={classes.totalLabelWrapper}>
          <Typography className={classes.summaryTitle} variant="subtitle1">
            {translations.ageTitle}
          </Typography>
        </div>
        <div className={classes.rows}>
          {Object.entries(headcountData?.total_employees_per_age).map(
            ([key, value]) => {
              return (
                <div key={`age_${key}`} className={classes.metricBlock}>
                  <div className={classes.rectangleWrapper}>
                    <div
                      className={classes.progress}
                      style={{
                        width: currentYearTotal
                          ? ((value || 0) * 133) / currentYearTotal
                          : 0,
                      }}
                    />
                  </div>
                  <div className={classes.valueWrapper}>
                    <Typography className={classes.label} variant="body1">
                      {key === NO_DATA_DEFAULT ? translations.noData : key}
                    </Typography>
                    <Typography className={classes.label} variant="subtitle1">
                      {value}
                    </Typography>
                  </div>
                </div>
              );
            }
          )}
        </div>
      </div>
    </div>
  );
};

HeadcountCards.propTypes = {
  translations: PropTypes.object.isRequired,
  headcountData: PropTypes.object.isRequired,
};

export default HeadcountCards;
